.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  width: 100%;
}

.headphones {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-subtle);
  border-radius: var(--tuna-shape-borderRadius);
}

.headphonesWhy {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
}

.phase {
  font-size: var(--tuna-typography-body1-fontSize);
  font-variant-numeric: tabular-nums;
}

.taking {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}
